import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Route } from '@angular/router';
import { UsersService } from '../users/users.service';

@Injectable({ providedIn: 'root' })
export class RequirePasswordUpdateGuard implements CanActivate {
  constructor(private router: Router, private usersService: UsersService) {}

  canLoad(route: Route): Promise<boolean> {
    return new Promise(resolve => {
      this.usersService
        .requirePasswordUpdate()
        .then(user => {
          resolve(true);
        })
        .catch(() => {
          this.router.navigate(['/profile/change-password'], { queryParams: { returnUrl: window.location.pathname } });
          resolve(false);
        });
    });

  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    return new Promise(resolve => {
      this.usersService
        .requirePasswordUpdate()
        .then(user => {
          resolve(true);
        })
        .catch(() => {
          this.router.navigate(['/profile/change-password'], { queryParams: { returnUrl: state.url } });
          resolve(false);
        });
    });

  }

  // canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
  //   return this.canActivate(childRoute, state);
  // }
}
